<template>
  <div :style="{ 'margin-bottom': displayNewDashboard ? '0px' : '30px' }">
    <navigation ref="nav" @logout="this.logout" />
    <window-resize />
    <transition name="slide">
      <div v-if="isNavOpened">
        <sidebar
          ref="sidebar"
          :menu-item-id="this.menuItemId"
          :user-site-map.sync="userMenu"
        />
      </div>
    </transition>
    <!-- Page Content -->
    <div v-if="isSearchOpened" class="blured-body" />
    <main
      class="page-content mt-6"
      :class="{ 'mobile-responsive': isMobile, open: isNavOpened }"
      :style="displayNewDashboard ? { 'background-color': '#F1F6F4' } : {}"
    >
      <router-view />
      <fab v-if="canShowHelpFab" :draggable="true" />
    </main>
  </div>
</template>

<script>
import Navigation from './components/Navigation';
import Sidebar from './components/Sidebar';
import WindowResize from './components/WindowResize';
import Fab from 'custom-floating-action-button';
import store, { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import { name as userModuleName } from '@/modules/user/store/';
import alert from '@/mixins/alert.mixin';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';

const TICKETS_ROUTE_NAME = 'CaseListMain';
const GUIDE_ROUTE_NAME = '';

export default {
  name: 'MainLayout',
  components: {
    navigation: Navigation,
    sidebar: Sidebar,
    WindowResize,
    Fab,
  },
  mixins: [alert],
  data() {
    return {
      windowWidth: 0,
      sessionExpired: false,
      fabItems: [
        {
          label: 'Mesa de Apoyo',
          icon: 'fal fa-user-headset',
          styles: {
            background: '#2DB782',
            color: '#fff',
          },
          route: TICKETS_ROUTE_NAME,
        },
        {
          label: 'Guías y Videos',
          icon: 'fal fa-globe',
          styles: {
            background: '#fff',
            color: '#2DB782',
          },
          route: GUIDE_ROUTE_NAME,
        },
      ],
      displayNewDasboardParameterValue: false,
    };
  },
  watch: {
    sessionExpired(newValue) {
      if (newValue) {
        this.showCloseAlert();
      }
    },
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
      isNavOpened: 'getIsNavOpen',
    }),
    canShowHelpFab() {
      return this.userHasPermissions('provider.helpfab.view');
    },
    showRequiredStudentModal() {
      return store.state.showRequiredStudentModal;
    },
    studentSelected() {
      return store.state.selectedStudent;
    },
    isSearchOpened() {
      return store.state.searchOpened;
    },
    ...mapState(userModuleName, ['userMenu', 'menuItemId', 'user']),
    displayNewDashboard() {
      return this.$route.path == '/' && this.displayNewDasboardParameterValue;
    },
  },
  async mounted() {
    this.activateActivityTracker();
    if (store.state.isLoggingOut) {
      this.showCloseAlert();
    }
    window.location.hash = '';
    const { data } = await _getSysparameterByNames({
      parameterNames: ['DisplayNewDashboardProviders'],
    });
    this.displayNewDasboardParameterValue =
      data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
  },
  methods: {
    ...mapActions(userModuleName, ['logout']),
    ...mapMutations(userModuleName, ['toggleNav', 'SET_USER_LOGOUT']),
    onCloseSidebar() {
      if (this.isMobile) {
        this.toggleNav();
      }
    },
    async showCloseAlert() {
      this.ShowAlert(
        'La sesión ha expirado',
        'Debe iniciar sesión nuevamente para continuar.',
        'error',
        async () => {
          this.logout();
        }
      );
    },
    activateActivityTracker() {
      window.addEventListener('mousemove', this.userActivityThrottler);
      window.addEventListener('scroll', this.userActivityThrottler);
      window.addEventListener('keydown', this.userActivityThrottler);
      window.addEventListener('resize', this.userActivityThrottler);
      window.addEventListener('beforeunload', this.deactivateActivityTracker);
    },
    deActivateActivityTracker() {
      window.removeEventListener('mousemove', this.userActivityThrottler);
      window.removeEventListener('scroll', this.userActivityThrottler);
      window.removeEventListener('keydown', this.userActivityThrottler);
      window.removeEventListener('resize', this.userActivityThrottler);
      window.removeEventListener(
        'beforeunload',
        this.deactivateActivityTracker
      );
    },
    userActivityThrottler() {
      if (!this.sessionExpired) {
        clearTimeout(this.userActivityThrottlerTimeout);
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.handleSessionExpiration();
          clearTimeout(this.userActivityThrottlerTimeout);
        }, process.env.VUE_APP_SESSION_TIMEOUT * 60000);
      }
    },
    async handleSessionExpiration() {
      this.sessionExpired = true;
      this.SET_USER_LOGOUT();
    },
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.userActivityThrottler);
    window.removeEventListener('scroll', this.userActivityThrottler);
    window.removeEventListener('keydown', this.userActivityThrottler);
    window.removeEventListener('resize', this.userActivityThrottler);
    clearTimeout(this.userActivityThrottlerTimeout);
  },
};
</script>

<style scope>
#main {
  margin-bottom: 30px;
}

.page-content {
  padding: 30px;
}

.page-content.open {
  margin-left: 118px;
}

.blured-body {
  left: 119px;
  top: 100px;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 11;
}

.blured-body {
  backdrop-filter: blur(8px);
}
</style>
